import React from 'react';
import Switch from '../Switch';
import { isMobile } from '../../helpers/utils';
import './style.css';
import './mobileStyles.css';

const Category = props => {
    const { header, items, exisitngValues } = props;
    const filteredItems =  items && items.filter(s => s.isVerified);

    return (
        <div className={isMobile() ? `mobile-font-family comp-category mobile-comp-category` : `comp-category`}>
            <div className={isMobile() ? `mobile-comp-category mobile-comp-category-heading` : `comp-category-heading`}>
                {isMobile() ? <h3 className="mobile-font-family mobile-category ">{header}</h3> : <h2>{header}</h2>}
                {isMobile() ? <h3 className="sr-only">{header}</h3> : <h2 className="sr-only">{header}</h2>}
            </div>
            <div className="comp-category-container">
                {
                    filteredItems.map((item, i) => (
                        <div className="comp-category-container-row" key={i}>
                            <div className="row-name-block">
                                <span className="sr-only">{`${header} ` + (i + 1)}</span>
                                <div className="row-name">{item.address}</div>
                            </div>
                            <div id={header + ` ` + i + item.address} className="row-control">
                                <Switch
                                    readValue={item.address}
                                    category={header}
                                    enabled={exisitngValues.includes(item.id)}
                                    onClick={
                                        () => {
                                            if (exisitngValues.includes(item.id)) {
                                                props.removeContactPreferences(item.address, item.id);
                                            } else {
                                                props.addContactPreferences(item.address, item.id);
                                            }
                                        }
                                    }
                                    isVerified={item.isVerified}
                                />
                            </div>
                        </div>
                    ))
                }
                {filteredItems.length === 0 && <div className="italic">

                   {header === "Push Notification" && "No devices found"}
                   
                  {header === "Email" && "No email found"} 
                   
                  {header === "Text Message" && "No Phone Numbers found"}

                    </div>}
            </div>
        </div>
    )
};

export default Category;
